// extracted by mini-css-extract-plugin
module.exports = {"accountModal":"styles_accountModal___2m0y","buttonsWrapper":"styles_buttonsWrapper__pi4aq"};